var map = {
	"./Volkswagen_Serial-Light-webfont": 1311,
	"./Volkswagen_Serial-Light-webfont.eot": 7733,
	"./Volkswagen_Serial-Light-webfont.svg": 1311,
	"./Volkswagen_Serial-Light-webfont.ttf": 3855,
	"./Volkswagen_Serial-Light-webfont.woff": 829,
	"./Volkswagen_Serial-Light-webfont.woff2": 8149,
	"./Volkswagen_Serial-Medium-webfont": 7240,
	"./Volkswagen_Serial-Medium-webfont.eot": 3162,
	"./Volkswagen_Serial-Medium-webfont.svg": 7240,
	"./Volkswagen_Serial-Medium-webfont.ttf": 8327,
	"./Volkswagen_Serial-Medium-webfont.woff": 8036,
	"./Volkswagen_Serial-Medium-webfont.woff2": 7726,
	"./Volkswagen_Serial-Regular-webfont": 3575,
	"./Volkswagen_Serial-Regular-webfont.eot": 2013,
	"./Volkswagen_Serial-Regular-webfont.svg": 3575,
	"./Volkswagen_Serial-Regular-webfont.ttf": 9127,
	"./Volkswagen_Serial-Regular-webfont.woff": 1349,
	"./Volkswagen_Serial-Regular-webfont.woff2": 5741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 708;